import { asset } from "$fresh/runtime.ts";
import type { JSX } from "preact";

export type AvailableIcons =
  | "Account"
  | "User"
  | "Heart"
  | "HeartFilled"
  | "Location"
  | "LocationCircle"
  | "Email"
  | "Phone"
  | "Clock"
  | "Package"
  | "Close"
  | "CloseModal"
  | "CloseOutline"
  | "Departments"
  | "Cart"
  | "Trash"
  | "Microphone"
  | "Menu"
  | "MagnifyingGlass"
  | "Offers"
  | "Minus"
  | "Plus"
  | "Pix"
  | "View"
  | "Home"
  | "Play"
  | "Check"
  | "Filter"
  | "FilterList"
  | "Grid"
  | "List"
  | "BtgEye"
  | "CreditCard"
  | "PixPdp"
  | "CheckedBox"
  | "Zoom"
  | "StarReview"
  | "StarReviewFilled"
  | "OrderByReview"
  | "Share"
  | "SharePdp"
  | "WhitePhone"
  | "ArrowBottom"
  | "ArrowLeft"
  | "ArrowLeftCircle"
  | "ArrowRight"
  | "ArrowRightCircle"
  | "ChevronRight"
  | "ChevronLeft"
  | "ChevronDown"
  | "Tiktok"
  | "Instagram"
  | "Facebook"
  | "Whatsapp"
  | ""; // This is necessary to prevent an icon from always being selected when the user has the option in the CMS admin panel to choose an icon.;

interface Props extends JSX.SVGAttributes<SVGSVGElement> {
  /**
   * Symbol id from element to render. Take a look at `/static/icons.svg`.
   *
   * Example: <Icon id="Bell" />
   */
  id: AvailableIcons;
  size?: number;
}

function Icon(
  { id, strokeWidth = 16, size, width, height, ...otherProps }: Props,
) {
  return (
    <svg
      {...otherProps}
      width={width ?? size}
      height={height ?? size}
      strokeWidth={strokeWidth}
    >
      <use href={asset(`/sprites.svg#${id}`)} />
    </svg>
  );
}

export default Icon;
